import { Flex, Separator, Button } from "@shared/primitive-components"
import { FC } from "react"
import { PricingPane, PricingPaneProps } from "../PricingPane"
import * as styles from "./pricingDetailsStyles"

interface PricingDetailsProps extends PricingPaneProps {
  actions?: ReadonlyArray<Action>
}

export type Action = Readonly<{
  title: string
  onClick: () => void
}>

export const PricingDetails: FC<PricingDetailsProps> = ({ premium, actions, children, css }) => (
  <PricingPane premium={premium} css={css}>
    <>
      {children}

      {actions && (
        <>
          <Separator size="hairlineFull" color="gray" />

          <Flex flexDirection="row-reverse" justifyContent="space-between" css={styles.buttonsWrap}>
            {actions.map(({ title, onClick }) => (
              <Button onClick={onClick} css={styles.button}>
                {title}
              </Button>
            ))}
          </Flex>
        </>
      )}
    </>
  </PricingPane>
)

PricingDetails.defaultProps = {
  actions: undefined,
}
